import React from 'react';
import { FuelCallout, FuelReload } from '@frete.com/fuel-react';
import TrackingTimeline from '@components/ui/TrackingTimeline';
import { formatDateDistance, formatHour } from '@utils/formatters/formatters';
import { hasOccurence } from '@utils/occurrence';
import Skeleton from './Skeleton';
import { LastLocationPropsInterface } from './LastLocationTypes';
import { text } from '../text';
import * as Styled from './LastLocationStyles';

function LastLocation({
  isDone,
  isLoading,
  location,
  occurrence,
  changedStatusAt,
  onClickReload,
  handleOccurrenceViewed,
}: LastLocationPropsInterface) {
  const { cityName, stateAcronym, updatedAt: locationUpdatedAt } = location;
  const updateAt = locationUpdatedAt
    ? new Date(locationUpdatedAt).toISOString()
    : new Date().toISOString();
  const hasOccurrence = occurrence && hasOccurence(occurrence);

  function getDataLastLocation(): { description: string; date?: string } {
    if (isDone) {
      return {
        description: text.location.done,
        date: changedStatusAt,
      };
    }

    if (!cityName) {
      return {
        description: text.location.noCity,
        date: new Date().toISOString(),
      };
    }

    return {
      description: `${cityName}, ${stateAcronym}`,
      date: locationUpdatedAt,
    };
  }

  function handleRenderLastLocation() {
    if (isLoading) {
      return <Skeleton />;
    }

    return (
      <TrackingTimeline
        name="modalMonitoringLastLocation"
        data={[
          {
            label: 'Última localização',
            inactive: !cityName,
            ...getDataLastLocation(),
          },
        ]}
      />
    );
  }

  if (hasOccurrence && handleOccurrenceViewed) {
    handleOccurrenceViewed({
      occurrenceId: occurrence.id,
      alreadyRead: occurrence.read,
    });
  }

  return (
    <Styled.Section>
      {!isDone && (
        <FuelReload
          onClick={() => onClickReload()}
          label={formatHour(updateAt)}
          loading={isLoading}
        />
      )}
      <Styled.Wrapper>
        {handleRenderLastLocation()}
        {hasOccurrence && (
          <Styled.WrapperCallout>
            <FuelCallout
              data-testid="fuelCallout-journey-occurence"
              heading={occurrence.reason}
              detail={formatDateDistance(occurrence.createdAt || '')}
              color="orange"
              icon="alert"
              fullWidth
            />
          </Styled.WrapperCallout>
        )}
      </Styled.Wrapper>
    </Styled.Section>
  );
}

export default LastLocation;
